import { FunctionComponent, useEffect } from "react";
import { useTranslation } from "react-i18next";

import { classNames } from "primereact/utils";

import "./FileUploadProgressBar.scss";

interface IFileUploadProgressBarProps {
  title?: string;
  showTitle?: boolean;
  columnTitleKeys: string[];
  columnProgressValues: number[];
}

export const FileUploadProgressBar: FunctionComponent<IFileUploadProgressBarProps> = ({
  title,
  showTitle = true,
  columnTitleKeys,
  columnProgressValues,
}: IFileUploadProgressBarProps) => {
  const { t } = useTranslation();

  useEffect(() => {
    if (columnTitleKeys.length !== columnProgressValues.length) {
      throw new Error("Column title keys and progress values must have the same length.");
    }
  }, [columnTitleKeys, columnProgressValues]);

  return (
    <div className="progress-wrapper">
      {title && showTitle ? <div className="progress-wrapper-title">{title}</div> : null}

      <div className="progress-bar-container">
        {columnProgressValues.map((progress: number, index: number) => (
          <div className="progress-column" key={columnTitleKeys[index]}>
            <div className="progress-bar">
              <div className="progress" style={{ width: `${progress}%` }} />

              <span>{progress.toFixed(progress !== 0 && progress !== 100 ? 1 : 0)}%</span>
            </div>

            <div className={classNames("progress-title", { "is-progressing": !!progress })}>
              {t(columnTitleKeys[index])}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
